// extracted by mini-css-extract-plugin
export var deleteIcon = "_qw-5";
export var deleteOption = "_qw-3";
export var divider = "_qw-2";
export var downloadIcon = "_qw-4";
export var drawer = "_qw-0";
export var drawerFooter = "_qw-6";
export var drawerOpen = "_qw-1";
export var highlighted = "_qw-7";
export var lighterHighlight = "_qw-8";